// src/Layout/AuthLayout.jsx
import React from "react";
import logo from "../assests/form_guru_logo.png";

const AuthLayout = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen bg-[var(--color-bg)] text-[var(--color-text)]">
      <main className="flex items-center justify-center flex-1 px-5 py-8">
        <div className="w-full max-w-[440px] text-center">
          <img
            src={logo}
            alt="Form Guru"
            className="xl:h-32 md:h-24 h-20 w-auto xl:mb-6 mb-4 mx-auto block"
          />
          {children}
        </div>
      </main>
    </div>
  );
};

export default AuthLayout;
